export const MIN_PADDING = 28;
export const ALL_CODE = '__ALL__';
export const ALL_LABEL = 'Alle';
export const SELECTION_LABEL = 'Auswahl';
export const CRUISES_ROUTE = '/cruises';
export const MISSING_FLIGHT_INFO = '-';
